export const defaultOptions = [
  "None Not at all",
  "Slight Rare, less than a day or two",
  "Mild Several days",
  "Moderate More than half the days",
  "Severe Nearly every day"
];

export const childQuestions_Level1 = [
  {
      id: 0,
      question: "Which country are you in?",
      options: [
        "India",
        "Indonesia",
        "Australia",
        "Afganistan",
        "Algeria",
        "Bermuda",
        "Zimbabwe",
      ],
      inputType: "select",
      category: "demographic",
      scores: [0, 0, 0, 0, 0, 0, 0],
    },
  {
    id: 1,
    question: "Have you noticed your child complaining often about feeling unwell or in pain, even when there doesn’t seem to be a clear physical reason?",
    options: defaultOptions,
    inputType: "radio",
    category: "SomaticSymptoms",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 2,
    question: "Seemed sad or depressed for several hours?",
    options: defaultOptions,
    inputType: "radio",
    category: "depression",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 3,
    question: "Had less fun doing things than he/she used to?",
    options: defaultOptions,
    inputType: "radio",
    category: "depression",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 4,
    question: "Seemed more irritated or easily annoyed than usual?",
    options:defaultOptions,
    inputType: "radio",
    category: "anger",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 5,
    question: "Seemed angry or lost his/her temper?",
    options: defaultOptions,
    inputType: "radio",
    category: "anger",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 6,
    question: "Had problems sleeping (falling asleep, staying asleep, or waking too early)?",
    options: defaultOptions,
    inputType: "radio",
    category: "sleep",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 7,
    question: "Said he/she felt nervous, anxious, or scared?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 8,
    question: "Not been able to stop worrying?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 9,
    question: "Said he/she couldn’t do things because they made him/her feel nervous?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 10,
    question: "Started more risky things or projects than usual?",
    options: defaultOptions,
    inputType: "radio",
    category: "mania",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 11,
    question: "Slept less than usual but still had lots of energy?",
    options: defaultOptions,
    inputType: "radio",
    category: "mania",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 12,
    question: "Had thoughts that something bad would happen to them or others?",
    options: defaultOptions,
    inputType: "radio",
    category: "ThoughtsAndBehaviors",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 13,
    question: "Said he/she had to check things over and over again (like door locks, stove, etc.)?",
    options: defaultOptions,
    inputType: "radio",
    category: "ThoughtsAndBehaviors",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 14,
    question: "Said he/she wanted to hurt or kill himself/herself in the past two weeks?",
    options: defaultOptions,
    inputType: "radio",
    category: "selfHarm",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 15,
    question: "Has he/she ever tried to kill himself/herself?",
    options: ["No", "Yes"],
    inputType: "radio",
    category: "selfHarm",
    scores: [0, 4]
  }
];

export const childLevel2Questions = {
  anxiety: [
    {
      id: 0,
      question: "Do you feel nervous when talking to classmates or teachers?",
      options: defaultOptions,
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4]
    },
    {
      id: 1,
      question: "Do you worry a lot about things you can’t control?",
      options: defaultOptions,
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4]
    }
  ],
  depression: [
    {
      id: 0,
      question: "Do you feel like you’re not good enough or that others are better than you?",
      options: defaultOptions,
      inputType: "radio",
      category: "depression",
      scores: [0, 1, 2, 3, 4]
    },
    {
      id: 1,
      question: "Do you find it hard to enjoy activities or hobbies you used to like?",
      options: defaultOptions,
      inputType: "radio",
      category: "depression",
      scores: [0, 1, 2, 3, 4]
    }
  ],
  anger: [
    {
      id: 0,
      question: "Do you often feel angry or annoyed even over small things?",
      options: defaultOptions,
      inputType: "radio",
      category: "anger",
      scores: [0, 1, 2, 3, 4]
    },
    {
      id: 1,
      question: "Have you gotten into fights or arguments more than usual lately?",
      options: defaultOptions,
      inputType: "radio",
      category: "anger",
      scores: [0, 1, 2, 3, 4]
    }
  ],
  selfHarm: [
    {
      id: 0,
      question: "Have you had thoughts about hurting yourself when you're upset?",
      options: defaultOptions,
      inputType: "radio",
      category: "selfHarm",
      scores: [0, 1, 2, 3, 4]
    },
    {
      id: 1,
      question: "Do you feel like no one would care if something bad happened to you?",
      options: defaultOptions,
      inputType: "radio",
      category: "selfHarm",
      scores: [0, 1, 2, 3, 4]
    }
  ],
  sleep: [
    {
      id: 0,
      question: "Do you find it hard to fall asleep or stay asleep at night?",
      options:defaultOptions,
      inputType: "radio",
      category: "sleep",
      scores: [0, 1, 2, 3, 4]
    },
    {
      id: 1,
      question: "Do you wake up feeling tired even after a full night's sleep?",
      options: defaultOptions,
      inputType: "radio",
      category: "sleep",
      scores: [0, 1, 2, 3, 4]
    }
  ],
  mania: [
    {
      id: 0,
      question: "Do you ever feel overly excited or full of energy even when others don’t?",
      options: defaultOptions,
      inputType: "radio",
      category: "mania",
      scores: [0, 1, 2, 3, 4]
    }
  ],
 somaticSymptoms: [
  {
    id: 0,
    question: "Do you often feel sick or have body aches without any clear reason?",
    options: defaultOptions,
    inputType: "radio",
    category: "somaticSymptoms",
    scores: [0, 1, 2, 3, 4]
  },
  {
    id: 1,
    question: "Do you get stomachaches or feel unwell when you're worried or upset?",
    options: defaultOptions,
    inputType: "radio",
    category: "somaticSymptoms",
    scores: [0, 1, 2, 3, 4]
  }
]

};
